import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { initFlowbite } from 'flowbite';
import { PwaInstallToastComponent } from './shared/components/pwa-install-toast/pwa-install-toast';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, PwaInstallToastComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit {
  ngOnInit(): void {
    initFlowbite();
  }
}
